(() => {
  function init(root = document) {
    root.querySelectorAll('.ms-menu').forEach(menu => {
      if (menu.dataset.initialized) return;
      menu.dataset.initialized = 'true';
      const expand = menu.querySelector('[data-ms-expand]');
      let category = 'mikate';
      let expanded = false;
      function update() {
        let count = 0;
        menu.querySelectorAll('[data-ms-category]').forEach(item => {
          const matches = item.dataset.msCategory === category;
          if (matches) count++;
          item.hidden = !matches || (Boolean(expand) && !menu.classList.contains('ms-full-menu') && category === 'mikate' && !expanded && count > 3);
        });
        if (expand) {
          expand.parentElement.hidden = category !== 'mikate' || count <= 3;
          expand.textContent = expanded ? 'Show favourites' : 'Explore all mikate';
          expand.setAttribute('aria-expanded', String(expanded));
        }
      }
      if (expand) expand.addEventListener('click', () => { expanded = !expanded; update(); });
      menu.querySelectorAll('[data-ms-filter]').forEach(button => {
        button.addEventListener('click', () => {
          menu.querySelectorAll('[data-ms-filter]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
          category = button.dataset.msFilter;
          update();
        });
      });
      if (expand) update();
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
